import {Link} from "@chakra-ui/react"
import {Link as GatsbyLink} from "gatsby"
import React from "react"
import {ChakraProps} from "@chakra-ui/system/dist/types/system.types";

interface Props extends ChakraProps {
    to: string;
    children: React.ReactNode
}

export default (props: Props) => {
    return <Link color="primary.500" as={GatsbyLink} {...props}/>
}
